<template>
  <el-card>
    <div class="pnl-bar" v-if="robot">
      <div>
        <span>系统机器人 UID {{ robot.id }}　余额</span>
        <b :class="pnlClass">{{ robot.balance }}</b>
        <el-tag :type="pnlType" size="mini" class="ml8">{{ pnlText }}</el-tag>
      </div>
      <div class="pnl-hint">
        系统奖励、尾雷赔付均由该账号发放，余额可为负；正数为平台盈利，负数为平台亏损
        <el-button type="text" @click="$router.push({ path: '/funds', query: { userId: robot.id } })">查看流水</el-button>
      </div>
    </div>
    <div class="toolbar">
      <el-input v-model="keyword" placeholder="账号/昵称/备注" clearable style="width:220px" @keyup.enter.native="load"></el-input>
      <el-select v-model="listFilter" class="ml8" style="width:130px" @change="onFilterChange">
        <el-option :value="''" label="全部用户"></el-option>
        <el-option :value="1" label="仅自控号"></el-option>
        <el-option :value="2" label="仅假人"></el-option>
      </el-select>
      <el-button type="primary" class="ml8" @click="page = 1; load()">查询</el-button>
      <el-button type="success" class="ml8" :loading="generating" @click="generateInvite">生成邀请用户</el-button>
    </div>
    <el-table :data="list" v-loading="loading" border>
      <el-table-column prop="id" label="ID" width="70"></el-table-column>
      <el-table-column label="头像" width="80" align="center">
        <template slot-scope="s">
          <img v-if="s.row.avatar" class="group-avatar-thumb" :src="s.row.avatar">
          <span v-else class="muted">—</span>
        </template>
      </el-table-column>
      <el-table-column prop="username" label="账号" width="120"></el-table-column>
      <el-table-column prop="nickname" label="昵称" width="140"></el-table-column>
      <el-table-column prop="remark" label="备注" min-width="140">
        <template slot-scope="s">
          <span>{{ s.row.remark || '—' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="余额" width="120">
        <template slot-scope="s">
          <span :class="isRobot(s.row) ? pnlClass : ''">{{ s.row.balance }}</span>
        </template>
      </el-table-column>
      <el-table-column label="机器人" width="110">
        <template slot-scope="s">
          <el-tag v-if="isRobot(s.row)" type="warning" size="mini">固定机器人</el-tag>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column label="自控号" width="120">
        <template slot-scope="s">
          <el-tag v-if="isControlled(s.row)" type="danger" size="mini">{{ (s.row.controlledMineCount || 0) }}雷</el-tag>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column label="假人" width="80">
        <template slot-scope="s">
          <el-tag v-if="isFake(s.row)" type="success" size="mini">假人</el-tag>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column label="假人开关" width="100" align="center">
        <template slot-scope="s">
          <el-switch
            v-if="isFake(s.row)"
            v-model="s.row.fakeEnabled"
            :active-value="1"
            :inactive-value="0"
            @change="onFakeEnabledChange(s.row)"
          ></el-switch>
          <span v-else class="muted">—</span>
        </template>
      </el-table-column>
      <el-table-column label="发包开关" width="100" align="center">
        <template slot-scope="s">
          <el-switch
            v-if="isFake(s.row)"
            v-model="s.row.fakeSendEnabled"
            :active-value="1"
            :inactive-value="0"
            :disabled="s.row.fakeEnabled !== 1"
            @change="onFakeSendEnabledChange(s.row)"
          ></el-switch>
          <span v-else class="muted">—</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="80">
        <template slot-scope="s">
          <el-tag :type="s.row.status === 1 ? 'success' : 'info'" size="mini">{{ s.row.status === 1 ? '启用' : '禁用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" width="170"></el-table-column>
      <el-table-column label="操作" min-width="480">
        <template slot-scope="s">
          <el-button v-if="canCopyInvite(s.row)" type="text" @click="copyInvite(s.row)">复制邀请链接</el-button>
          <span v-if="canCopyInvite(s.row) && s.row.inviteUsedAt" class="muted">{{ s.row.inviteDeviceId ? '已绑定设备' : '已使用' }}</span>
          <el-button v-if="canUnbindDevice(s.row)" type="text" style="color:#E6A23C" @click="confirmUnbindDevice(s.row)">解绑设备</el-button>
          <el-button v-if="!isRobot(s.row)" type="text" @click="openControlled(s.row)">自控号规则</el-button>
          <el-button v-if="!isRobot(s.row)" type="text" @click="openFake(s.row)">假人设置</el-button>
          <el-button type="text" @click="openEdit(s.row)">编辑</el-button>
          <el-button type="text" @click="openScore(s.row, 'up')">上分</el-button>
          <el-button type="text" @click="openScore(s.row, 'down')">下分</el-button>
          <el-button v-if="!isRobot(s.row)" type="text" style="color:#F56C6C" @click="remove(s.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top:12px"
      background
      layout="total,sizes,prev,pager,next"
      :total="total"
      :page-sizes="[10, 20, 50, 100, 200]"
      :page-size="size"
      :current-page.sync="page"
      @size-change="onSizeChange"
      @current-change="load"
    ></el-pagination>

    <el-dialog title="编辑用户" :visible.sync="dialog" width="460px">
      <el-form :model="form" label-width="80px">
        <el-form-item label="账号">
          <el-input v-model="form.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="重置密码">
          <el-input v-model="form.password" placeholder="不填则不修改"></el-input>
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="form.nickname"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" placeholder="用户端聊天和个人页会显示此备注"></el-input>
        </el-form-item>
        <el-form-item label="头像">
          <el-upload
            action="#"
            :http-request="uploadAvatar"
            :show-file-list="false"
            accept="image/*"
          >
            <div class="group-avatar-uploader">
              <img v-if="form.avatar" :src="form.avatar">
              <i v-else class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="!isRobot(form)" label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="!isRobot(form)" label="自控号">
          <el-switch v-model="form.isControlled" :active-value="1" :inactive-value="0" :disabled="form.isFake === 1"></el-switch>
          <div v-if="form.isFake === 1" class="pnl-hint">假人不能同时设为自控号</div>
        </el-form-item>
        <el-form-item v-if="!isRobot(form) && form.isControlled === 1" label="固定雷数">
          <el-input-number v-model="form.controlledMineCount" :min="0" :max="10" :step="1"></el-input-number>
          <div class="pnl-hint">该用户发埋雷红包时，生成金额中会固定包含这么多个雷</div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialog = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="'自控号规则 - ' + controlledForm.name" :visible.sync="controlledDialog" width="440px">
      <el-form :model="controlledForm" label-width="90px">
        <el-form-item label="自控号">
          <el-switch v-model="controlledForm.isControlled" :active-value="1" :inactive-value="0" :disabled="controlledSaving" @change="onControlledSwitch"></el-switch>
        </el-form-item>
        <el-form-item v-if="controlledForm.isControlled === 1" label="固定雷数">
          <el-input-number v-model="controlledForm.controlledMineCount" :min="0" :max="10" :step="1"></el-input-number>
        </el-form-item>
        <div class="pnl-hint">
          设为自控号后，该用户发出的埋雷红包会按雷数生成金额，例如设为 2 雷，则拆出的金额里一定有两个尾数命中埋雷数字。福利红包不受影响。
        </div>
      </el-form>
      <div slot="footer">
        <el-button @click="controlledDialog = false">取消</el-button>
        <el-button type="primary" @click="saveControlled">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="'假人设置 - ' + fakeForm.name" :visible.sync="fakeDialog" width="560px">
      <el-form :model="fakeForm" label-width="140px">
        <el-form-item label="假人">
          <el-switch v-model="fakeForm.isFake" :active-value="1" :inactive-value="0" :disabled="fakeSaving"></el-switch>
        </el-form-item>
        <el-form-item v-if="fakeForm.isFake === 1" label="假人开关">
          <el-switch v-model="fakeForm.fakeEnabled" :active-value="1" :inactive-value="0" :disabled="fakeSaving" @change="onFakeRunningFormChange"></el-switch>
          <div class="pnl-hint">关闭后不再自动发包、抢包，发包开关也会关闭。该用户仍可在「仅假人」里筛选到</div>
        </el-form-item>
        <el-form-item v-if="fakeForm.isFake === 1" label="发包开关">
          <el-switch v-model="fakeForm.fakeSendEnabled" :active-value="1" :inactive-value="0" :disabled="fakeSaving || fakeForm.fakeEnabled !== 1"></el-switch>
          <div class="pnl-hint">假人开关打开后才能操作。打开后自动发包并抢包；关闭后只抢包、不发包</div>
        </el-form-item>
        <el-form-item label="发包间隔下限">
          <el-input-number v-model="fakeForm.fakeSendIntervalMin" :min="1" :max="86400" :step="1" :precision="0"></el-input-number>
          <span class="ml8">秒</span>
        </el-form-item>
        <el-form-item label="发包间隔上限">
          <el-input-number v-model="fakeForm.fakeSendIntervalMax" :min="1" :max="86400" :step="1" :precision="0"></el-input-number>
          <span class="ml8">秒</span>
        </el-form-item>
        <el-form-item label="抢包时间下限">
          <el-input-number v-model="fakeForm.fakeGrabDelayMin" :min="0" :max="86400" :step="1" :precision="0"></el-input-number>
          <span class="ml8">秒</span>
        </el-form-item>
        <el-form-item label="抢包时间上限">
          <el-input-number v-model="fakeForm.fakeGrabDelayMax" :min="0" :max="86400" :step="1" :precision="0"></el-input-number>
          <span class="ml8">秒</span>
        </el-form-item>
        <el-form-item label="发包金额">
          <el-input-number v-model="fakeForm.fakeSendAmount" :min="0.01" :max="999999" :precision="2" :step="10"></el-input-number>
        </el-form-item>
        <el-form-item label="发包个数">
          <el-input-number v-model="fakeForm.fakeSendCount" :min="1" :max="100" :step="1" :precision="0"></el-input-number>
        </el-form-item>
        <div v-if="fakeForm.isFake === 1 && fakeForm.fakeNextSendAt" class="pnl-hint">下次发包：{{ fakeForm.fakeNextSendAt }}</div>
        <div class="pnl-hint">
          假人开关打开后无需登录，会自动抢包。发包开关也打开时，系统在发包间隔下限到上限之间随机等待，然后在他已加入且未关闭的每个群各发一个红包。别人在这些群发包时，他会在抢包时间下限到上限之间随机等待后抢一份，不抢自己发的包。发包开关关闭时只抢包、不发包。假人开关关闭时，发包和抢包都停止。余额低于发包金额时，暂停发包和抢包。埋雷红包的雷号在 0-9 之间随机。假人不能同时是自控号。
        </div>
      </el-form>
      <div slot="footer">
        <el-button @click="fakeDialog = false">取消</el-button>
        <el-button type="primary" :loading="fakeSaving" @click="saveFake">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="(scoreForm.action === 'up' ? '上分' : '下分') + ' - ' + scoreForm.name" :visible.sync="scoreDialog" width="400px">
      <el-form :model="scoreForm" label-width="80px">
        <el-form-item label="金额">
          <el-input-number v-model="scoreForm.amount" :min="0.01" :precision="2" :step="10"></el-input-number>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="scoreForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="scoreDialog = false">取消</el-button>
        <el-button type="primary" @click="submitScore">确定</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { users as fetchUsers, generateInviteUser, updateUser, deleteUser, score as changeScore, robot as fetchRobot, upload, unbindDevice } from '../api'

const CONTROLLED_SECOND_PASSWORD = '760767'

export default {
  name: 'Users',
  data() {
    return {
      loading: false,
      generating: false,
      keyword: '',
      listFilter: '',
      page: 1,
      size: 10,
      total: 0,
      list: [],
      robot: null,
      dialog: false,
      form: { id: null, username: '', password: '', nickname: '', remark: '', avatar: '', status: 1, isControlled: 0, controlledMineCount: 2, isFake: 0 },
      formOriginal: { isControlled: 0, controlledMineCount: 2 },
      controlledDialog: false,
      controlledSaving: false,
      controlledSwitchSilent: false,
      controlledForm: { id: null, name: '', isControlled: 0, controlledMineCount: 2, secondPassword: '' },
      fakeDialog: false,
      fakeSaving: false,
      fakeForm: {
        id: null,
        name: '',
        isFake: 0,
        fakeEnabled: 1,
        fakeSendEnabled: 1,
        fakeSendIntervalMin: 60,
        fakeSendIntervalMax: 120,
        fakeGrabDelayMin: 2,
        fakeGrabDelayMax: 5,
        fakeSendAmount: 10,
        fakeSendCount: 5,
        fakeNextSendAt: ''
      },
      scoreDialog: false,
      scoreForm: { id: null, action: 'up', amount: 100, remark: '' }
    }
  },
  computed: {
    pnlValue() {
      return this.robot && this.robot.balance != null ? Number(this.robot.balance) : 0
    },
    pnlClass() {
      if (this.pnlValue > 0) return 'pnl-plus'
      if (this.pnlValue < 0) return 'pnl-minus'
      return 'pnl-flat'
    },
    pnlType() {
      if (this.pnlValue > 0) return 'success'
      if (this.pnlValue < 0) return 'danger'
      return 'info'
    },
    pnlText() {
      if (this.pnlValue > 0) return '平台盈利'
      if (this.pnlValue < 0) return '平台亏损'
      return '持平'
    }
  },
  created() {
    this.load()
  },
  methods: {
    isRobot(row) {
      return row && (row.id === 1 || row.isRobot === 1)
    },
    isControlled(row) {
      return row && row.isControlled === 1
    },
    isFake(row) {
      return row && row.isFake === 1
    },
    canCopyInvite(row) {
      return !this.isRobot(row) && !!row.inviteToken
    },
    canUnbindDevice(row) {
      return this.canCopyInvite(row) && !!row.inviteDeviceId
    },
    inviteUrl(token) {
      const host = location.hostname
      let origin
      if (/^admin\./i.test(host)) {
        origin = location.protocol + '//' + host.replace(/^admin\./i, 'www.')
      } else if (host === 'localhost' || host === '127.0.0.1') {
        origin = location.protocol + '//' + host + ':8081'
      } else {
        origin = location.origin
      }
      return origin + '/#/invite/' + encodeURIComponent(token)
    },
    copyInvite(row) {
      const url = this.inviteUrl(row.inviteToken)
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => {
          this.$message.success('邀请链接已复制')
        }).catch(() => {
          this.fallbackCopy(url)
        })
      } else {
        this.fallbackCopy(url)
      }
    },
    fallbackCopy(text) {
      const el = document.createElement('textarea')
      el.value = text
      el.setAttribute('readonly', 'readonly')
      el.style.position = 'fixed'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()
      try {
        document.execCommand('copy')
        this.$message.success('邀请链接已复制')
      } catch (e) {
        this.$message.error('复制失败，请手动复制：' + text)
      }
      document.body.removeChild(el)
    },
    confirmUnbindDevice(row) {
      const name = row.remark || row.nickname || row.username
      this.$confirm(
        '解绑后该邀请链接可在新设备上重新绑定，当前设备将被踢下线。确定解绑用户「' + name + '」的设备吗？',
        '解绑设备',
        { type: 'warning' }
      ).then(() => {
        return unbindDevice(row.id)
      }).then(() => {
        this.$message.success('已解绑设备')
        this.load()
      }).catch((e) => {
        if (e && e.message) this.$message.error(e.message)
      })
    },
    loadRobot() {
      fetchRobot().then((data) => {
        this.robot = data
      }).catch(() => {
        this.robot = null
      })
    },
    onSizeChange(val) {
      this.size = val
      this.page = 1
      this.load()
    },
    onFilterChange() {
      this.page = 1
      this.load()
    },
    load() {
      this.loading = true
      this.loadRobot()
      const params = { page: this.page, size: this.size, keyword: this.keyword }
      if (this.listFilter === 1) {
        params.controlled = 1
      }
      if (this.listFilter === 2) {
        params.fake = 1
      }
      fetchUsers(params).then((data) => {
        this.list = data.records || []
        this.total = data.total || 0
      }).catch((e) => {
        this.$message.error(e.message)
      }).then(() => {
        this.loading = false
      })
    },
    generateInvite() {
      this.generating = true
      generateInviteUser().then(() => {
        this.$message.success('已生成，请复制邀请链接')
        this.page = 1
        this.load()
      }).catch((e) => {
        this.$message.error(e.message)
      }).then(() => {
        this.generating = false
      })
    },
    askSecondPassword() {
      return this.$prompt('请输入二次密码', '二次密码验证', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'password',
        inputPlaceholder: '请输入二次密码',
        closeOnClickModal: false,
        inputValidator(val) {
          if (!val) return '请输入二次密码'
          if (val !== CONTROLLED_SECOND_PASSWORD) return '二次密码错误'
          return true
        }
      }).then(({ value }) => value)
    },
    controlledPayload(isControlled, mineCount, secondPassword) {
      return {
        isControlled,
        controlledMineCount: isControlled === 1 ? mineCount : 0,
        secondPassword
      }
    },
    persistControlled(id, isControlled, mineCount, secondPassword) {
      return updateUser(id, this.controlledPayload(isControlled, mineCount, secondPassword))
    },
    openEdit(row) {
      const isControlled = row.isControlled === 1 ? 1 : 0
      const controlledMineCount = row.controlledMineCount == null ? 2 : row.controlledMineCount
      this.form = {
        id: row.id,
        username: row.username,
        password: '',
        nickname: row.nickname,
        remark: row.remark || '',
        avatar: row.avatar || '',
        status: row.status,
        isControlled,
        controlledMineCount,
        isFake: row.isFake === 1 ? 1 : 0
      }
      this.formOriginal = { isControlled, controlledMineCount }
      this.dialog = true
    },
    openControlled(row) {
      if (this.isFake(row)) {
        this.$message.warning('该用户已是假人，请先关闭假人')
        return
      }
      this.askSecondPassword().then((value) => {
        this.controlledSwitchSilent = true
        this.controlledForm = {
          id: row.id,
          name: row.remark || row.nickname || row.username,
          isControlled: row.isControlled === 1 ? 1 : 0,
          controlledMineCount: row.isControlled === 1
            ? (row.controlledMineCount == null ? 2 : row.controlledMineCount)
            : (row.controlledMineCount == null || row.controlledMineCount === 0 ? 2 : row.controlledMineCount),
          secondPassword: value
        }
        this.controlledDialog = true
        this.$nextTick(() => {
          this.controlledSwitchSilent = false
        })
      }).catch(() => {})
    },
    onControlledSwitch(val) {
      if (this.controlledSwitchSilent || !this.controlledDialog) {
        return
      }
      this.controlledSaving = true
      this.persistControlled(
        this.controlledForm.id,
        val,
        this.controlledForm.controlledMineCount,
        this.controlledForm.secondPassword
      ).then(() => {
        this.$message.success(val === 1 ? '已设为自控号' : '已关闭自控号')
        this.load()
      }).catch((e) => {
        this.$message.error(e.message)
        this.controlledSwitchSilent = true
        this.controlledForm.isControlled = val === 1 ? 0 : 1
        this.$nextTick(() => {
          this.controlledSwitchSilent = false
        })
      }).then(() => {
        this.controlledSaving = false
      })
    },
    saveControlled() {
      this.persistControlled(
        this.controlledForm.id,
        this.controlledForm.isControlled,
        this.controlledForm.controlledMineCount,
        this.controlledForm.secondPassword
      ).then(() => {
        this.$message.success('自控号规则已保存')
        this.controlledDialog = false
        this.load()
      }).catch((e) => {
        this.$message.error(e.message)
      })
    },
    uploadAvatar(req) {
      upload(req.file, 'avatar').then((d) => {
        this.$set(this.form, 'avatar', d.url)
        req.onSuccess && req.onSuccess(d)
      }).catch((e) => {
        this.$message.error(e.message)
        req.onError && req.onError(e)
      })
    },
    revertFakeSwitch(row, next) {
      row._fakeSwitchSilent = true
      row.fakeEnabled = next === 1 ? 0 : 1
      this.$nextTick(() => {
        row._fakeSwitchSilent = false
      })
    },
    revertFakeSendSwitch(row, next) {
      row._fakeSendSilent = true
      row.fakeSendEnabled = next === 1 ? 0 : 1
      this.$nextTick(() => {
        row._fakeSendSilent = false
      })
    },
    onFakeEnabledChange(row) {
      if (row._fakeSwitchSilent) {
        return
      }
      const next = row.fakeEnabled
      this.askSecondPassword().then((secondPassword) => {
        const payload = { fakeEnabled: next, secondPassword }
        if (next !== 1) {
          payload.fakeSendEnabled = 0
        }
        return updateUser(row.id, payload).then(() => {
          if (next !== 1) {
            row.fakeSendEnabled = 0
            this.$message.success('已关闭，不再发包、抢包')
          } else {
            this.$message.success(row.fakeSendEnabled === 1 ? '已开启，将自动发包、抢包' : '已开启，将自动抢包')
          }
        })
      }).catch((e) => {
        this.revertFakeSwitch(row, next)
        if (e && e.message) this.$message.error(e.message)
      })
    },
    onFakeSendEnabledChange(row) {
      if (row._fakeSendSilent) {
        return
      }
      if (row.fakeEnabled !== 1) {
        this.revertFakeSendSwitch(row, 1)
        return
      }
      const next = row.fakeSendEnabled
      this.askSecondPassword().then((secondPassword) => {
        return updateUser(row.id, { fakeSendEnabled: next, secondPassword }).then(() => {
          this.$message.success(next === 1 ? '已开启自动发包' : '已关闭自动发包，仍会抢包')
        })
      }).catch((e) => {
        this.revertFakeSendSwitch(row, next)
        if (e && e.message) this.$message.error(e.message)
      })
    },
    onFakeRunningFormChange(val) {
      if (val !== 1) {
        this.fakeForm.fakeSendEnabled = 0
      }
    },
    openFake(row) {
      if (this.isControlled(row)) {
        this.$message.warning('该用户已是自控号，请先关闭自控号')
        return
      }
      this.fakeForm = {
        id: row.id,
        name: row.remark || row.nickname || row.username,
        isFake: row.isFake === 1 ? 1 : 0,
        fakeEnabled: row.fakeEnabled === 0 ? 0 : 1,
        fakeSendEnabled: row.fakeEnabled === 0 || row.fakeSendEnabled === 0 ? 0 : 1,
        fakeSendIntervalMin: row.fakeSendIntervalMin == null ? 60 : row.fakeSendIntervalMin,
        fakeSendIntervalMax: row.fakeSendIntervalMax == null ? 120 : row.fakeSendIntervalMax,
        fakeGrabDelayMin: row.fakeGrabDelayMin == null ? 2 : row.fakeGrabDelayMin,
        fakeGrabDelayMax: row.fakeGrabDelayMax == null ? 5 : row.fakeGrabDelayMax,
        fakeSendAmount: row.fakeSendAmount == null ? 10 : Number(row.fakeSendAmount),
        fakeSendCount: row.fakeSendCount == null ? 5 : row.fakeSendCount,
        fakeNextSendAt: row.fakeNextSendAt || ''
      }
      this.fakeDialog = true
    },
    saveFake() {
      if (this.fakeForm.isFake === 1) {
        const sendMin = this.fakeForm.fakeSendIntervalMin
        const sendMax = this.fakeForm.fakeSendIntervalMax
        const grabMin = this.fakeForm.fakeGrabDelayMin
        const grabMax = this.fakeForm.fakeGrabDelayMax
        const amount = Number(this.fakeForm.fakeSendAmount)
        const count = this.fakeForm.fakeSendCount
        if (sendMin == null || sendMax == null || sendMin < 1 || sendMax > 86400 || sendMax < sendMin) {
          this.$message.error('发包间隔需在1到86400秒之间，且下限不能大于上限')
          return
        }
        if (grabMin == null || grabMax == null || grabMin < 0 || grabMax > 86400 || grabMax < grabMin) {
          this.$message.error('抢包时间需在0到86400秒之间，且下限不能大于上限')
          return
        }
        if (!(amount >= 0.01)) {
          this.$message.error('发包金额不能小于0.01')
          return
        }
        if (count == null || count < 1 || count > 100) {
          this.$message.error('发包个数需在1到100之间')
          return
        }
      }
      this.askSecondPassword().then((secondPassword) => {
        this.fakeSaving = true
        return updateUser(this.fakeForm.id, {
          isFake: this.fakeForm.isFake,
          fakeEnabled: this.fakeForm.isFake === 1 ? this.fakeForm.fakeEnabled : 0,
          fakeSendEnabled: this.fakeForm.isFake === 1 && this.fakeForm.fakeEnabled === 1 ? this.fakeForm.fakeSendEnabled : 0,
          fakeSendIntervalMin: this.fakeForm.fakeSendIntervalMin,
          fakeSendIntervalMax: this.fakeForm.fakeSendIntervalMax,
          fakeGrabDelayMin: this.fakeForm.fakeGrabDelayMin,
          fakeGrabDelayMax: this.fakeForm.fakeGrabDelayMax,
          fakeSendAmount: this.fakeForm.fakeSendAmount,
          fakeSendCount: this.fakeForm.fakeSendCount,
          secondPassword
        }).then(() => {
          this.$message.success(this.fakeForm.isFake === 1 ? '假人设置已保存' : '已取消假人')
          this.fakeDialog = false
          this.load()
        })
      }).catch((e) => {
        if (e && e.message) this.$message.error(e.message)
      }).then(() => {
        this.fakeSaving = false
      })
    },
    save() {
      if (this.form.isFake === 1 && this.form.isControlled === 1) {
        this.$message.error('假人不能设为自控号')
        return
      }
      const payload = {
        username: this.form.username,
        password: this.form.password,
        nickname: this.form.nickname,
        remark: this.form.remark,
        avatar: this.form.avatar,
        status: this.form.status
      }
      const mineCount = this.form.isControlled === 1 ? this.form.controlledMineCount : 0
      const controlledChanged = this.form.isControlled !== this.formOriginal.isControlled
        || mineCount !== this.formOriginal.controlledMineCount
      const submit = (secondPassword) => {
        if (controlledChanged) {
          Object.assign(payload, this.controlledPayload(this.form.isControlled, this.form.controlledMineCount, secondPassword))
        }
        return updateUser(this.form.id, payload).then(() => {
          this.$message.success('保存成功')
          this.dialog = false
          this.load()
        })
      }
      const pending = controlledChanged
        ? this.askSecondPassword().then((password) => submit(password))
        : submit()
      pending.catch((e) => {
        if (e && e.message) this.$message.error(e.message)
      })
    },
    remove(row) {
      this.$confirm('确定删除用户「' + row.nickname + '」吗？', '提示', { type: 'warning' }).then(() => {
        return deleteUser(row.id)
      }).then(() => {
        this.$message.success('已删除')
        this.load()
      }).catch((e) => {
        if (e && e.message) this.$message.error(e.message)
      })
    },
    openScore(row, action) {
      this.scoreForm = {
        id: row.id,
        action,
        amount: 100,
        remark: action === 'up' ? '管理员上分' : '管理员下分',
        name: row.nickname
      }
      this.scoreDialog = true
    },
    submitScore() {
      changeScore(this.scoreForm.id, this.scoreForm).then(() => {
        this.$message.success('操作成功')
        this.scoreDialog = false
        this.load()
      }).catch((e) => {
        this.$message.error(e.message)
      })
    }
  }
}
</script>
